import { render, staticRenderFns } from "./JobsView.vue?vue&type=template&id=2f08b35a&scoped=true&"
import script from "./JobsView.vue?vue&type=script&setup=true&lang=js&"
export * from "./JobsView.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f08b35a",
  null
  
)

export default component.exports